import React from 'react'
import CameraSection from './sub/CameraSection'
import AA from './sub/AA'
import ServicesSection from './sub/ServicesSection'
import FeaturedProducts from './sub/FeaturedProducts'
import Herosection from './sub/Herosection'
import ScrollCarousel from './sub/ScrollCarousel'
import SliderSection from './sub/SliderSection'
import ServicesPage from './sub/ServicesPage'
import Connectsection from '../Services/sub/Connectsection'
import Subsubabout from '../About/sub/SubAbout'

export default function Home() {
  return (
    <>
    <SliderSection />
    {/* <ScrollCarousel /> */}
    {/* <Herosection /> */}
    <Subsubabout />
    <CameraSection />
    <Connectsection />
    {/* <AA /> */}
    {/* <ServicesPage /> */}
    {/* <ServicesSection /> */}
    {/* <FeaturedProducts /> */}
    </>
  )
}
